// loginHS 제품 감지 — DocuAI(문서추출)와 같은 build 를 두 도메인이 공유(P0)하므로
//   런타임에 도메인(loginhs.tlogin.net / loginhs.co.kr) 또는 dev 의 ?product=loginhs 로 분기.
//   App.js(랜딩·기본진입)·Sidebar(메뉴 필터) 공통 사용.
export function isLoginHSProduct() {
  try {
    if (typeof window === "undefined") return false;
    const h = window.location.hostname || "";
    if (/(^|\.)loginhs\./i.test(h)) return true;
    return (
      new URLSearchParams(window.location.search).get("product") === "loginhs"
    );
  } catch (_e) {
    return false;
  }
}
